import { TextFieldSize } from '../text-field';
import { TextFieldGroupConfig } from './text-field-group-config';

export class TextFieldGroupBuilder {
  horizontal: boolean;
  size: TextFieldSize;

  static textFieldGroup(): TextFieldGroupBuilder {
    return new TextFieldGroupBuilder();
  }

  withHorizontal(horizontal = true): TextFieldGroupBuilder {
    this.horizontal = horizontal;
    return this;
  }

  withSize(size = TextFieldSize.Default): TextFieldGroupBuilder {
    this.size = size;
    return this;
  }

  build(): TextFieldGroupConfig {
    return new TextFieldGroupConfig({
      horizontal: this.horizontal,
      size: this.size
    });
  }

}
